import React, {useEffect, useState} from 'react';
import logo from '../pics/logo-1.png'
import {Spinner} from 'react-bootstrap';
import Search from '../components/SearchBar';
import ImageBox from '../components/ImageBox';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getProducts } from '../store/productSlice';

function Home(){

let navigate = useNavigate(); 
const dispatch = useDispatch();
const { products, loading, error} = useSelector( state => state.products)
const [filteredProducts, setFilteredProducts] = useState([]);
const [homeState, setHomeState] = useState('unfiltered')

useEffect(()=>{
   dispatch(getProducts())
},[dispatch])

function filterProducts(filter){
  let filtered = products?.filter( item => item.category == filter)
  setFilteredProducts(filtered)
  setHomeState('filtered')
}
 
   return(
   loading ? 
      (
         <div className='flex one center'>
           <Spinner/>
         </div>
      ) 
      : 
      (
         <div className='flex one column grey-background'>
        <div className='flex two column'>
          <div className='flex one center'>
             <img src={logo} id='img'/>
          </div>
          <div className='flex one center'>
            <Search/>
          </div>
        </div>
        <div className='flex one'>
          <div className='flex one center'>
            <div className='category-box flex center' onClick={()=>{ filterProducts("Rings")}}>
               <span className='white-txt small-txt'>Rings</span>
            </div>
          </div>
          <div className='flex one center'>
            <div className='category-box flex center' onClick={()=>{ filterProducts("Necklaces")}}>
                <span className='white-txt small-txt'>Necklaces</span>
            </div>
          </div>
          <div className='flex one center'>
            <div className='category-box flex center' onClick={()=>{ filterProducts("Bracelets")}}>
                <span className='white-txt small-txt'>Bracelets</span>
            </div>
          </div>
            <div className='flex one center'>
            <div className='category-box flex center' onClick={()=>{ filterProducts("Earrings")}}>
                <span className='white-txt small-txt'>Earrings</span>
            </div>
          </div>
          <div className='flex one center'>
            <div className='category-box flex center' onClick={()=>{ filterProducts("Watches")}}>
                <span className='white-txt small-txt'>Watches</span>
            </div>
          </div>
        </div>
        <div className='flex seven wrap space-evenly overflow gap min-0'>
          { homeState == 'unfiltered' ?
          (
                products && products.length > 0 && (
                    products.map(el =>{
                      return(
                          <ImageBox src={el.mainImage} name={el.productName} price={el.price} onClick={()=>{navigate(`/product/${el.id}`, {state: {product: el}})}} subImages={el.subImages}/>
                      )
                    })
                )
          )
        :
        (
                 filteredProducts && filteredProducts.length > 0 && (
                    filteredProducts.map(el =>{
                      return(
                          <ImageBox src={el.mainImage} name={el.productName} price={el.price} onClick={()=>{navigate(`/product/${el.id}`, {state: {product: el}})}} subImages={el.subImages}/>
                      )
                    })
                ) 
        )
        }
         
        
        </div>
    </div>
      )
   )
}

export default Home